import { FormPath } from '@formily/shared';
import { isEmpty } from 'lodash';

/**
 *  表单校验，照着formily源码submit那部分写的。 这部分不这么写，直接调用 form.validate()会清除effects里set的error，比较奇怪。
 */
export const formValidate = async (actions, path = '') => {
  await actions.validate(path, {
    throwErrors: false,
    hostRendering: true
  });
  const validated = actions.getFormState(state => {
    var _state$errors;

    return {
      // FIXED:
      // 当传入path得时候 说明校验得只是这部分的内容，那么表格内其他部分的内容有错误 不应该算校验失败。
      // 实际案例：比如表单当中存在一个表格，那么表格点添加的时候只应该校验表格内部的内容是不是有问题，而不是说校验整个表单内容是不是有问题
      errors: isEmpty(path) ? state.errors : (_state$errors = state.errors) === null || _state$errors === void 0 ? void 0 : _state$errors.filter(n => {
        return FormPath.parse(path).match(n.path);
      })
    };
  });
  const {
    errors
  } = validated; // 校验失败

  if (errors.length) {
    throw errors;
  }
};
//# sourceMappingURL=es/utils/formValidate.js.map